const locale = {
    ctm: 'CTM',
    ctm_tft: 'TFT',
    ctm_a_measurement: 'A Measurement',
	face_photo:'切羽写真',
    scanner:'スキャナ',
    assessment:'切羽判定',
    street_view:'ストリートビュー',
    tunnel_remote_view:'リモートビュー',
    tunnel_face_assessment_system:'AI切羽画像評価システム',
    face_camera:'切羽カメラ',
    a_measurement:'A計測',
    b_measurement:'B計測',
    tft:'TFT探査',
    step_mgmt:'歩掛り',
    process_simulator:'歩掛り管理システム',
    no_data_project: '{{プロジェクト名}} を選びました。 このプロジェクトには CTM に関連されているデータはありません。',
    DM: '{{categoryCode}} ({{date}})',
    //LHF: '切羽（下半）({{date}})',
    //UHF: '切羽（上半）({{date}})',
    LHF: '下半({{date}})',
    UHF: '上半({{date}})',
    lining: '覆工 ({{date}})',
    cross_section_name:'断面名称',
    measurement_positions:'計測位置',
    construction_project_name:'工事名',
    drawing_name:'図面名',
    date_of_creation:'作成日',
    station_name:'測点名',
    constructor:'施工者',
    client:'発注者',
    page_number: 'Page {{pageNumber}} of {{numPages}}',
    name:'軸',
    number:'番号',
    face_line:'切羽進捗',
    upphlf:'上半',
    lowhf:'下半',
    invertMeas:'インバート',
    x_axis_title:'[日付] 延べ日数(日)',
    safety_threshold:'管理基準',
    title_y_axis: '内空変位・沈下量(mm)',
    title_y2_axis:'切羽離れ(m)',
    title_page:"aMeasurement | SCAI",
    title_page_landing:"CTM | SCAI",
    title_page_tft:"TFT | SCAI",
    //lower_half_face:'切羽（下半）',
    lower_half_face:'下半',
    lining_concrete:'覆工',
    invert:'インバート',
    //upper_half_face:'切羽（上半）',
    upper_half_face:'上半',
    /*pit_side:'坑口側',*/
    pit_side:'発進側',
    arrival_side:'到達側',
    min_max: '項目',
    value: '値',
    update_y_axis:'Y軸',
    y_axis:'Y軸',
    update_x_axis:'X軸',
    x_axis:'X軸',
    threshold: '管理基準値',
    print:'印刷',
    interval_y_axis:'軸Y間隔',
    interval_y2_axis:'軸Y2間隔',
    settleTop: '天端',
    settleUpLeft: '左上',
    settleUpRight: '右上',
    settleLowLeft: '左下',
    settleLowRight: '右下',
    start_date: '最小(日)',
    number_days: '経過日数',
    max: '最大',
    min: '最小',
    scale_interval: '目盛間隔',
    loading:"読み込み中",
    downloading_image:'イメージのダウンロード...',
    graph_is_being_generated: 'グラフ生成中',
    select_a_project_to_load_CTM_data: 'CTMデータを選択してください',
    tunnel_image:"トンネルイメージ",
    search_project: '現場検索',
    code:'工事コード',
    branch: '現場支店:',
    last_update: '最後更新',
    status: 'ステータス',
    file_name: 'ファイル名',

    zoomIn: '拡大',
    zoomOut: '縮小',
    zoomReset: 'リセット',
    
    type_desired_td: '表示する切羽のTDを入力',
    settle: '天端沈下',
    disp: '内空変位'
};

export default locale;